(function (root) {
  'use strict';

  function normalizeValue(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function optionName(option) {
    if (typeof option === 'string') return option;
    return option && (option.name || option.value) ? option.name || option.value : '';
  }

  function findOptionIndex(options, acceptedNames) {
    var accepted = (acceptedNames || []).map(normalizeValue);
    return (options || []).findIndex(function (option) {
      return accepted.indexOf(normalizeValue(optionName(option))) !== -1;
    });
  }

  function isDefaultOnlyProduct(product) {
    if (!product || !Array.isArray(product.variants) || product.variants.length !== 1) return false;
    if (product.has_only_default_variant === true) return true;
    var options = product.options || [];
    var variantOptions = product.variants[0].options || [];
    return options.length <= 1 && normalizeValue(variantOptions[0]) === 'default title';
  }

  function buildVariantChoices(product, configuredColour) {
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return [];

    if (isDefaultOnlyProduct(product)) {
      var onlyVariant = product.variants[0];
      return [{
        id: Number(onlyVariant.id),
        size: 'One size',
        available: Boolean(onlyVariant.available),
        autoSelected: true,
      }];
    }

    var colourIndex = findOptionIndex(product.options, ['color', 'colour']);
    var sizeIndex = findOptionIndex(product.options, ['size']);
    var colourKey = normalizeValue(configuredColour);
    if (colourIndex < 0 || sizeIndex < 0 || colourIndex === sizeIndex || !colourKey) return [];
    if (!Array.isArray(product.options) || product.options.length !== 2) return [];

    var seenSizes = Object.create(null);
    return product.variants.reduce(function (choices, variant) {
      var options = Array.isArray(variant.options) ? variant.options : [];
      if (options.length !== product.options.length) return choices;
      if (normalizeValue(options[colourIndex]) !== colourKey) return choices;
      var size = String(options[sizeIndex] == null ? '' : options[sizeIndex]).trim();
      if (!size || seenSizes[normalizeValue(size)]) return choices;
      seenSizes[normalizeValue(size)] = true;
      choices.push({
        id: Number(variant.id),
        size: size,
        available: Boolean(variant.available),
        autoSelected: false,
      });
      return choices;
    }, []);
  }

  function createAddPayload(set, braVariantId, bottomVariantId, sectionsUrl) {
    var braId = Number(braVariantId);
    var bottomId = Number(bottomVariantId);
    var slug = String(set && set.slug ? set.slug : '').trim();
    if (!Number.isFinite(braId) || braId <= 0 || !Number.isFinite(bottomId) || bottomId <= 0) {
      throw new Error('Two valid variant IDs are required.');
    }
    if (!slug) throw new Error('A set identifier is required.');

    return {
      items: [
        {
          id: braId,
          quantity: 1,
          properties: {
            _formwynn_set: slug,
            _formwynn_set_role: 'bra',
          },
        },
        {
          id: bottomId,
          quantity: 1,
          properties: {
            _formwynn_set: slug,
            _formwynn_set_role: 'bottom',
          },
        },
      ],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: sectionsUrl || '/',
    };
  }

  root.FormwynnSetEventCore = {
    normalizeValue: normalizeValue,
    findOptionIndex: findOptionIndex,
    buildVariantChoices: buildVariantChoices,
    createAddPayload: createAddPayload,
  };
})(typeof window !== 'undefined' ? window : globalThis);
